import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Comments from '@src/pc/components/Comments';
import styles from './index.css';
import Header from './Header';

const Layout = ({ content }) => {
    const { event, params, docData } = content;
    const { subjectId } = params;

    // 主评论：优先用 allData.docData，否则回退到 event 字段
    const base62Id = docData?.base62Id || event?.base62Id || subjectId;
    const docName = docData?.title || event?.title || '';
    const skey = docData?.skey || event?.skey || '';

    return (
        <div className={styles.layout}>
            <Header content={event} />
            <Comments
                subjectId={subjectId}
                docUrl={`ucms_${base62Id}`}
                docName={docName}
                skey={skey}
            />
        </div>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
